import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthErrorType, ERROR_CONFIGS, ErrorConfig } from '../auth-error-display/auth-error-display.component';

@Component({
    selector: 'app-auth-error-modal',
    templateUrl: './auth-error-modal.component.html',
    styleUrls: [
        '../auth-error-display/auth-error-display.component.scss',
        './auth-error-modal.component.scss',
    ],
    standalone: false
})
export class AuthErrorModalComponent {
  @Input() type: AuthErrorType = 'error';
  @Input() title?: string;
  @Input() message?: string;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  get config(): ErrorConfig {
    const config = ERROR_CONFIGS[this.type];

    return {
      ...config,
      title: this.title ?? config.title,
      message: this.message ?? config.message,
    };
  }

  close(): void {
    this.activeModal.close(false);
  }

  contactSupport(): void {
    this.activeModal.close(true);
  }
}
